import { Component, OnDestroy, OnInit } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { Subscription } from 'rxjs';
import { FacilityService } from '../../../core/services/facility.service';
import {RFIDMemberResponse } from '../../../core/services/facility.model';
import {RfidMemberService} from '../../services/rfid-member.service';
import { environment } from '../../../../environments/environment';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { CommonUtil } from '../../../core/Utils/common-util';


@Component({
  selector: 'app-rfid',
  templateUrl: './rfid.component.html',
  styleUrls: ['./rfid.component.scss']
})
export class RfidComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  members: any;
  currentFacility:any;
  totalMembersCount: any;
  cloudBasePath: string;
  hasEditPermission: boolean;

  constructor(private rootScopeService: RootScopeService,private _facilityService: FacilityService, 
    private _rfidMemberService:RfidMemberService, private _loader:HaloLoaderService,
    private _commonUtil: CommonUtil) { }
  private _facilityOnChange: Subscription;

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'rfid';
  }

  ngOnInit() {
    this.getRootScopeData();
    this.setPageName();     
    this.cloudBasePath = environment.cloudBasePath;
    if (this._facilityService.selectedFacilityId()) {
      this.getMembers();
    }

    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      if(this.currentFacility.summary.userRights.facility === 'F')
        this.hasEditPermission = true;
      else
        this.hasEditPermission = false;
      this.getMembers();
    });
    this._commonUtil.scrollTop();
   
    if(this.currentFacility.summary.userRights.facility === 'F')
      this.hasEditPermission = true;
    else
      this.hasEditPermission = false;
    
  }

  ngOnDestroy(): void {
    this._facilityOnChange?.unsubscribe();
  }
  
  getMembers() {
    this.currentFacility = this._facilityService.selectedFacility();
    this._loader.startProcess();
    this._rfidMemberService.getRFIDMembers(this.currentFacility.facilityId).subscribe(
      (data) => {
        this.members = data.members;
        this.totalMembersCount=data.totalMembersCount;
        this._loader.endProcess();
      },
      error => {
        console.error('API failed.');
        this._loader.endProcess();
      }
    );
  }

  onRefresh() {
    this.getMembers();
  }
}



